var map = {
	"./connect 2.png": 241,
	"./connect.png": 242,
	"./eatwell 2.png": 243,
	"./eatwell.png": 244,
	"./fun 2.png": 245,
	"./fun.png": 246,
	"./get-moving 2.png": 247,
	"./get-moving.png": 248,
	"./give 2.png": 249,
	"./give.png": 250,
	"./growmind 2.png": 251,
	"./growmind.png": 252,
	"./money 2.png": 253,
	"./money.png": 254,
	"./plant 2.png": 255,
	"./plant.png": 256,
	"./sleep-well 2.png": 257,
	"./sleep-well.png": 258,
	"./take-notice 2.png": 259,
	"./take-notice.png": 260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;